import * as React from 'react';
import {observer, useLocalObservable} from "mobx-react-lite";
import {IocStore} from "../stores/ioc";
import {Alert, Button, Col, Form} from 'react-bootstrap';
import {FormEvent} from "react";
import {requests} from "../api";
import Backdrop from "../components/Backdrop";
import {useHistory} from "react-router-dom";

const ReportPage = observer(function ReportPage(props: { store: IocStore }) {
    const history = useHistory<{ check: string }>()
    const localState = useLocalObservable(() => ({
        comment: '',
        ioc: props.store.ioc,
        contact: true,
        error: '',
        validated: false,
        loading: false,
        reportSent: false
    }))

    if (!localState.ioc) {
        history.replace('/')
    }

    const handleReport = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        localState.validated = true
        const isValid = e.currentTarget.checkValidity()
        if (!isValid) return false

        localState.loading = true
        localState.error = ''

        requests.post(
            '/user/report',
            JSON.stringify({ioc: localState.ioc, comment: localState.comment, contact: localState.contact}),
            {Authorization: props.store.code}
            ).then(() => {
                localState.reportSent = true
            }).catch((err) => {
                localState.error = err.message === "Forbidden" ? "Invalid auth code" : err.message
            }).finally(() => {
                localState.loading = false
            })
    }

    return <>
        <h3>Report false positive to ThreatSTOP</h3>
        {localState.error ? <Alert variant="danger">{localState.error}</Alert> : ''}
        {localState.reportSent && <Alert variant="success">Thank you, your report has been successfully sent.</Alert>}
        {!localState.reportSent && <Form noValidate validated={localState.validated} onSubmit={handleReport}>
            <Backdrop hidden={!localState.loading}/>
            <Form.Row>
                <Form.Group as={Col}>
                    <Form.Label>IOC</Form.Label>
                    <Form.Control
                        type="text"
                        defaultValue={props.store.ioc}
                        onChange={(e) => localState.ioc = e.target.value}
                    />
                    <Form.Control.Feedback type="invalid">
                        Invalid IOC
                    </Form.Control.Feedback>
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col}>
                    <Form.Label>Comments</Form.Label>
                    <Form.Control
                        type="text"
                        defaultValue=""
                        placeholder="short explanation why you think this is false positive"
                        required
                        onChange={(e) => localState.comment = e.target.value}
                    />
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group controlId="formBasicCheckbox" as={Col}>
                    <Form.Check
                        type="checkbox"
                        label="Contact me with results"
                        defaultChecked
                        onChange={(e) => {
                            // @ts-ignore
                            localState.contact = e.target.checked
                        }}
                    />
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col}>
                    <Button type="submit">Submit</Button>
                </Form.Group>
            </Form.Row>
        </Form>}
    </>
})

export default ReportPage